import { render, staticRenderFns } from "./MA10Print.vue?vue&type=template&id=96628dd8&scoped=true&"
import script from "./MA10Print.vue?vue&type=script&lang=js&"
export * from "./MA10Print.vue?vue&type=script&lang=js&"
import style0 from "./MA10Print.vue?vue&type=style&index=0&id=96628dd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96628dd8",
  null
  
)

export default component.exports